<ms-dashboard-sidebar-student data-cy="student-sidebar" *ngIf="isStudent"></ms-dashboard-sidebar-student>
<ms-dashboard-sidebar-teacher data-cy="teacher-sidebar" *ngIf="isTeacher"></ms-dashboard-sidebar-teacher>
<div class="filler" [ngClass]="{ 'filler--shrink': isShrinkFixed }"></div>

<div class="wrapper" (scroll)="onScroll($event)">
    <div class="content">
        <router-outlet></router-outlet>
        <!-- <div class="tabs-filler"></div> -->
    </div>

    <ms-dashboard-navigation-tabs data-cy="student-navigation-tabs" class="navigation-tabs" *ngIf="isStudent"></ms-dashboard-navigation-tabs>
    <ms-dashboard-navigation-tabs data-cy="teacher-navigation-tabs" class="navigation-tabs" *ngIf="isTeacher"></ms-dashboard-navigation-tabs>
</div>
